import { render } from "./AdminDialog.vue?vue&type=template&id=8f4960ec"
import script from "./AdminDialog.vue?vue&type=script&lang=js"
export * from "./AdminDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__